import { StatusBadge } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { patientMedicalInformationTranslationKeys } from '../../translations';

export const MedicalInformationAttachmentStatus = (): JSX.Element => {
   return (
      <StatusBadge testId={'medicalInformationAttachmentStatus'} type={'unapproved'}>
         <Translate>{patientMedicalInformationTranslationKeys.previewModal.attachmentRemoved}</Translate>
      </StatusBadge>
   );
};
